<template>
  <div class="index-article" @click="goHomeArticlelist('1')">
    <flex-line class="article-wrapper" :show-border="true" style="border: 0;">
      <div class="wrapper">

        <img style="width: 12px;height: 16px;" src="../../../assets/image/home/zx.png" />

        <div class="title">
          {{ $t('HotSale') }}
          <!-- <span style="color:#000">最新</span>资讯 -->
        </div>

        <!-- <ul class="scroll-content" :style="{ top }">
          <li v-for="(item, index) in items" :key="index" @click="goArticleDetail(item)">
            {{ item.article_title }}
          </li>
        </ul> -->
      </div>
      <!-- <div slot="right" class="more common-btn" @click="goHomeArticlelist('1')">点击查看</div> -->
    </flex-line>
  </div>
</template>

<script>
import flexLine from '../../flexLine'
export default {
  name: 'IndexArticle',
  data() {
    return {
      activeIndex: 0
    }
  },
  components: {
    flexLine
  },
  props: ['items'],
  computed: {
    top() {
      return -this.activeIndex * 2 + 'rem'
    }
  },
  beforeDestroy: function () {
    clearInterval(this.time_interval)
  },
  mounted() {
    let _this = this
    this.time_interval = setInterval(function () {
      if (_this.activeIndex < (_this.items.length - 1)) {
        _this.activeIndex += 1
      } else {
        _this.activeIndex = 0
      }
    }, 2000)
  },
  methods: {
    goHomeArticlelist(acId) {
      this.$router.push({ name: 'HomeArticlelist', query: { ac_id: acId } })
    },
    goArticleDetail(item) {
      this.$router.push({ 'name': 'HomeArticledetail', 'query': { 'article_id': item.article_id } })
    }
  }
}
</script>

<style scoped lang="scss">
.index-article {
  padding-left: .7rem;
  padding-right: .7rem;
  background: #fff;
  // padding-bottom: $modelSpace;

  .article-wrapper {
    margin: 0 $pageSpace;

    .wrapper {
      height: 2rem;
      line-height: 2rem;
      overflow: hidden;
      display: flex;
      align-items: center;

    }
  }
}

.title {
  text-align: center;
  font-size: $mainFontSize;
  font-weight: 700;
  color: $primaryColor;
  padding: 0 0.5rem;
  font-size: 13px;
  color: #000000;
  padding-right: 0;
  font-weight: 500;
}

.more {
  background: $primaryGradualColor;
  color: #fff;
  box-shadow: 0px 2px 4px #ffd5d7;
}

.scroll-content {
  align-self: flex-start;
  flex: 1;
  position: relative;
  transition: top 0.5s;

  li {
    line-height: 2rem;
    text-align: left;
    font-size: $fontSize;
    // color: $descTextColor;
    font-weight: normal;
  }
}
</style>
